import React from "react";
import { node, string } from "prop-types";
import { Col } from "../Grid";
import Link from "../Link";
import Icon from "../Icon";
import { classes } from "../utils/classes";

const FooterSocial = ({ children }) => {
	return <Col spacing={{ pt: 0 }}>{children}</Col>;
};

FooterSocial.propTypes = {
	children: node.isRequired,
};

export const FooterSocialItemLink = ({ name, href, className = "", ...props }) => {
	return (
		<Link
			isBaseClassName={false}
			href={href}
			className={classes("footer__social_item-link", className)}
			{...props}
		>
			<Icon name={name} />
		</Link>
	);
};

FooterSocialItemLink.propTypes = {
	name: string.isRequired,
	href: string.isRequired,
	className: string,
};

export default FooterSocial;
